import axios from "axios";
import { PDA_PREFIX } from "../../global/constants";
import { toast } from "react-toastify";

export const GET_ALL_SCOPE_GROUPS_REQUEST = "GET_ALL_SCOPE_GROUPS_REQUEST";
export const GET_ALL_SCOPE_GROUPS_SUCCESS = "GET_ALL_SCOPE_GROUPS_SUCCESS";
export const GET_ALL_SCOPE_GROUPS_ERROR = "GET_ALL_SCOPE_GROUPS_ERROR";
export const ADD_SCOPE_GROUP_REQUEST = "ADD_SCOPE_GROUP_REQUEST";
export const ADD_SCOPE_GROUP_SUCCESS = "ADD_SCOPE_GROUP_SUCCESS";
export const ADD_SCOPE_GROUP_ERROR = "ADD_SCOPE_GROUP_ERROR";
export const UPDATE_SCOPE_GROUP_REQUEST = "UPDATE_SCOPE_GROUP_REQUEST";
export const UPDATE_SCOPE_GROUP_SUCCESS = "UPDATE_SCOPE_GROUP_SUCCESS";
export const UPDATE_SCOPE_GROUP_ERROR = "UPDATE_SCOPE_GROUP_ERROR";
export const DELETE_SCOPE_GROUP_REQUEST = "DELETE_SCOPE_GROUP_REQUEST";
export const DELETE_SCOPE_GROUP_SUCCESS = "DELETE_SCOPE_GROUP_SUCCESS";
export const DELETE_SCOPE_GROUP_ERROR = "DELETE_SCOPE_GROUP_ERROR";

const getAllScopeGroupsRequest = () => ({
  type: GET_ALL_SCOPE_GROUPS_REQUEST,
});

const getAllScopeGroupsSuccess = (data) => ({
  type: GET_ALL_SCOPE_GROUPS_SUCCESS,
  payload: data,
});

const getAllScopeGroupsError = (err) => ({
  type: GET_ALL_SCOPE_GROUPS_ERROR,
  payload: err,
});

export const getAllScopeGroups = () => async (dispatch) => {
  dispatch(getAllScopeGroupsRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/breakdown-structure`);
    dispatch(getAllScopeGroupsSuccess(res.data));
  } catch (err) {
    dispatch(getAllScopeGroupsError(err));
    toast.error("Something went wrong. Please contatct support");
  }
};

const updateScopeGroupRequest = () => ({
  type: UPDATE_SCOPE_GROUP_REQUEST,
});

const updateScopeGroupSuccess = (data) => ({
  type: UPDATE_SCOPE_GROUP_SUCCESS,
  payload: data,
});

const updateScopeGroupError = (err) => ({
  type: UPDATE_SCOPE_GROUP_ERROR,
  payload: err,
});

export const updateScopeGroup = (data) => async (dispatch) => {
  dispatch(updateScopeGroupRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/breakdown-structure`, data);
    dispatch(updateScopeGroupSuccess(res.data));
  } catch (err) {
    dispatch(updateScopeGroupError(err));
    toast.error("Something went wrong. Please contatct support");
  }
};

const deleteScopeGroupRequest = () => ({
  type: DELETE_SCOPE_GROUP_REQUEST,
});

const deleteScopeGroupSuccess = (data) => ({
  type: DELETE_SCOPE_GROUP_SUCCESS,
  payload: data,
});

const deleteScopeGroupError = (err) => ({
  type: DELETE_SCOPE_GROUP_ERROR,
  payload: err,
});

export const deleteScopeGroup = (id) => async (dispatch) => {
  dispatch(deleteScopeGroupRequest());
  try {
    await axios.delete(`${PDA_PREFIX}/breakdown-structure/${id}`);
    dispatch(deleteScopeGroupSuccess(id));
    toast.success("Deletion done !");
  } catch (err) {
    dispatch(deleteScopeGroupError(err));
    toast.error("Something went wrong. Please contatct support");
  }
};

const addScopeGroupRequest = () => ({
  type: ADD_SCOPE_GROUP_REQUEST,
});

const addScopeGroupSuccess = (data) => ({
  type: ADD_SCOPE_GROUP_SUCCESS,
  payload: data,
});

const addScopeGroupError = (err) => ({
  type: ADD_SCOPE_GROUP_ERROR,
  payload: err,
});

export const addScopeGroup = (data) => async (dispatch) => {
  dispatch(addScopeGroupRequest());
  try {
    const res = await axios.post(`${PDA_PREFIX}/breakdown-structure`, data);
    dispatch(addScopeGroupSuccess(res.data));
    toast.success("Group created !");
  } catch (err) {
    dispatch(addScopeGroupError(err));
    toast.error(
      "Something went wrong during creation. Please contatct support"
    );
  }
};
